import script from "./OutputPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./OutputPanel.vue?vue&type=script&setup=true&lang=ts"

import "./OutputPanel.vue?vue&type=style&index=0&id=6e2c1c1b&lang=css"

const __exports__ = script;

export default __exports__